import { intersect, literal, struct, union } from 'io-ts/Decoder';

import { Id as ClientId } from '../../../../../client/Id';
import { Id as UserId } from '../../../../../user/Id';

export const Request = intersect(
	struct({
		userId: UserId,
	})
)(
	union(
		// ? Other entities in a single API?
		struct({
			type: literal('client'),
			clientId: ClientId,
		})
	)
);
